import { BrowserRouter, Routes, Route } from "react-router-dom";
import LinkPage from "./components/LinkPage/LinkPage";
import ConfigGenerator from "./components/ConfigGenerator/ConfigGenerator";
import ErrorPage from "./components/ErrorPage/ErrorPage";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LinkPage />} />
        <Route path="/generator" element={<ConfigGenerator />} />
        <Route path="/:productId" element={<LinkPage />} />
        <Route path="/404" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;